import React from 'react';
import { useAppDispatch, useCallback, useAuth0 } from 'hooks';
import { SignUpForm } from 'components';
import { type SignUpFormDto, type SignUpUserRequestItem } from 'types/types';
import { userActions } from 'utils/store';
import { UserRole } from 'types/enums';
import { getFacilitiesId } from 'utils';

export const SignUp = () => {
  const dispatch = useAppDispatch();
  const { user } = useAuth0();

  const handleFormSubmit = useCallback(
    (payload: SignUpFormDto) => {
      const { study, conditions, dateOfBirth, gender, medicalRecordNumber, race, facilities, ...data } = payload;
      const filteredConditions = conditions.map((condition) => condition.id);
      const patient =
        +data.role === UserRole.PATIENT
          ? { medicalRecordNumber, dateOfBirth, conditions: filteredConditions, gender, race, study }
          : {};

      const formattedFacilities = facilities?.length ? getFacilitiesId(facilities) : [];

      const newUser: SignUpUserRequestItem = {
        ...data,
        email: user?.email,
        study,
        patient,
        facilities: formattedFacilities,
      };
      dispatch(userActions.createUser(newUser));
    },
    [dispatch, user?.email],
  );

  return <SignUpForm onSubmit={handleFormSubmit} />;
};
